import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"

const programs = [
	{
		icon: "ri-graduation-cap-line",
		title: "Integrated +1 & +2 Education",
		desc: "Science & Commerce streams with a strong academic foundation and board exam excellence.",
		color: "#8B6820"
	},
	{
		icon: "ri-book-open-line",
		title: "Entrance Coaching",
		desc: "Structured preparation for NEET, JEE, KEAM, CUET and other national-level exams.",
		color: "#C4935A"
	},
	{
		icon: "ri-briefcase-4-line",
		title: "Professional Pathways",
		desc: "CA Foundation preparation and early exposure to commerce & business career tracks.",
		color: "#C4935A"
	},
	{
		icon: "ri-global-line",
		title: "Global University Pathways",
		desc: "International admissions counseling, scholarship guidance, and profile development.",
		color: "#8B6820"
	},
	{
		icon: "ri-robot-line",
		title: "AI & Future Skills",
		desc: "Artificial Intelligence programs, leadership training, and digital career-ready skills.",
		color: "#C4935A"
	},
]

const Programes = () => {
	return (
		<div className="programes-main">
			<div className="container-main">
				<div className="row">
					<div className="col-lg-12 text-center mb-5">
						<h5 className="path-samll-text montserrat">What We Offer</h5>
						<h1 className="programe-heading montserrat">Our <span className="programe-block-text">Programs</span></h1>
					</div>
					<div className="col-lg-12">
						<Swiper
							modules={[Pagination]}
							spaceBetween={24}
							pagination={{ clickable: true }}
							breakpoints={{
								0: { slidesPerView: 1, spaceBetween: 16 },
								600: { slidesPerView: 2, spaceBetween: 20 },
								992: { slidesPerView: 3, spaceBetween: 24 }
							}}
							className="programs-swiper"
						>
							{programs.map((prog, idx) => (
								<SwiperSlide key={idx}>
									<div className="program-card">
										<div className="program-icon-wrap" style={{ backgroundColor: prog.color }}>
											<i className={prog.icon}></i>
										</div>
										<h5 className="program-card-title">{prog.title}</h5>
										<p className="program-card-desc">{prog.desc}</p>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Programes
